import React from 'react'
import PropTypes from 'prop-types'
import { PopularItemImage } from '../PopularItemImage/PopularItemImage'

import { MenuItemCard } from '../../MenuItemCard/MenuItemCard'

export const PopularItem = ({ item }) => {
  const { imageUrl } = item

  return (
    <MenuItemCard
      item={item}
      dataTestid='popular-item-link'
      endAdornment={<PopularItemImage imageUrl={imageUrl} />}
    />
  )
}

const itemShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired,
  itemGroupGuid: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  price: PropTypes.number
})

PopularItem.propTypes = {
  item: itemShape.isRequired
}
